
namespace Gamification.Gamification {
    export class UtentiDelegatiColumns {
        static columnsKey = 'Gamification.UtentiDelegati';
    }
}